import { render, staticRenderFns } from "./PasswordRemindChange.vue?vue&type=template&id=9a27fc1c&scoped=true&"
import script from "./PasswordRemindChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordRemindChange.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordRemindChange.vue?vue&type=style&index=0&id=9a27fc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a27fc1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VForm,VImg,VRow})
